import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { Button } from 'reactstrap';

import { useAddTechnicianModalStore } from './Modals/AddTechnicanModal/AddTechnicianModalStore';

import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';
import { ObjectItem } from 'api/clients/types';

interface ClientsTableExpandableProps {
  data: ObjectItem;
  setSelectedObject: (obj: ObjectItem | undefined) => void;
  setIsDeleteModalOpen: (isOpen: boolean) => void;
  setIsManageObjectModalOpen: (isOpen: boolean) => void;
}
const ClientsTableExpandable: React.FC<ClientsTableExpandableProps> = ({
  data,
  setSelectedObject,
  setIsDeleteModalOpen,
  setIsManageObjectModalOpen,
}) => {
  const { t } = useTranslation();
  const mobile = useMediaQuery(MediaBreakpoints.mobile);
  const tablet = useMediaQuery(MediaBreakpoints.tablet);
  const desktop = useMediaQuery(MediaBreakpoints.desktop);
  const largeDesctop = useMediaQuery(MediaBreakpoints.largeDesktop);
  const { open: openAddTechnicianModal } = useAddTechnicianModalStore();

  return (
    <div className="d-flex w-100 flex-column mx-3">
      {largeDesctop && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('ClientTable.titles.amount-traps')}</span>
          </div>
          <div>
            <span>{data.mct_count + data.smst_count + data.srst_count + data.srbm_count}</span>
          </div>
        </div>
      )}
      {desktop && (
        <>
          <div className="d-flex flex-column my-2">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('ClientTable.titles.owner')}</span>
            </div>
            <div>
              <span>{data.owner ? data.owner.first_name + ' ' + data.owner.last_name : '-'}</span>
            </div>
          </div>
        </>
      )}
      {tablet && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">{t('ClientTable.titles.city')}</span>
          </div>
          <div>
            <span>{data.address}</span>
          </div>
        </div>
      )}
      {mobile && (
        <>
          <div className="d-flex flex-column my-2">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('ClientTable.titles.actions')}</span>
            </div>
            <div>
              <div className="btn-group mt-4 mt-sm-0" role="group">
                <button
                  type="button"
                  className="btn btn-sm btn-ghost-primary btn-icon"
                  onClick={() => {
                    setSelectedObject(data);
                    setIsManageObjectModalOpen(true);
                  }}
                >
                  <i className="ri-pencil-fill" />
                </button>
                <button type="button" className="btn btn-sm btn-ghost-primary btn-icon">
                  <a href={`object/traps/${data.slug}`} type="button" className="m-0 p-0">
                    <i className="ri-eye-fill" />
                  </a>
                </button>
                <button
                  onClick={() => {
                    setIsDeleteModalOpen(true);
                    setSelectedObject(data);
                  }}
                  type="button"
                  className="btn btn-sm btn-ghost-primary btn-icon"
                >
                  <span className="remove-item-btn">
                    <i className="ri-delete-bin-6-fill" />
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column my-2">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('ClientTable.titles.technician')}</span>
            </div>
            <div>
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <Button
                    onClick={() => {
                      openAddTechnicianModal(data.slug);
                    }}
                    type="button"
                    className="btn btn-sm btn-rounded rounded-5 btn-soft-success custom-toggle waves-light"
                    title="Add tecgnician"
                  >
                    <span className="icon-on fs-5">
                      <i className="ri-add-circle-fill align-bottom" />
                    </span>
                  </Button>
                </div>
                <div className="avatar-group">
                  {data.technicians.map(tech => (
                    <div
                      className={`avatar-group-item ${tech.is_lead && 'border-warning'} d-flex align-items-center`}
                      key={tech.technician.id}
                    >
                      <a href={`/user/${tech.id}/detail`} target="_blank" rel="noreferrer">
                        <img
                          src={`${tech.technician.avatar}`}
                          alt={tech.technician.last_name}
                          title={`${tech.technician.last_name} ${tech.technician.first_name}`}
                          className="rounded-circle avatar-xs"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ClientsTableExpandable;
